import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { MagnifyingGlass } from '@phosphor-icons/react';

export function UserFilters({ search, setSearch, roleFilter, setRoleFilter, statusFilter, setStatusFilter, setPage, onSearch }) {
  const handleSubmit = (e) => {
    e.preventDefault();
    setPage(1);
    onSearch();
  };

  return (
    <Card className="bg-[#1A1A1A] border-[#222222] rounded-lg mb-6">
      <CardContent className="p-4">
        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
          <div className="flex-1 relative">
            <MagnifyingGlass className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#666666]" />
            <Input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search by name, email, or username..."
              className="pl-9 bg-[#111111] border-[#333333] text-white rounded-lg h-10"
              data-testid="user-search-input"
            />
          </div>
          <Select value={roleFilter} onValueChange={(v) => { setRoleFilter(v); setPage(1); }}>
            <SelectTrigger className="w-32 bg-[#111111] border-[#333333] text-white rounded-lg h-10" data-testid="role-filter">
              <SelectValue placeholder="Role" />
            </SelectTrigger>
            <SelectContent className="bg-[#1A1A1A] border-[#333333]">
              <SelectItem value="all">All Roles</SelectItem>
              <SelectItem value="user">Users</SelectItem>
              <SelectItem value="admin">Admins</SelectItem>
            </SelectContent>
          </Select>
          <Select value={statusFilter} onValueChange={(v) => { setStatusFilter(v); setPage(1); }}>
            <SelectTrigger className="w-32 bg-[#111111] border-[#333333] text-white rounded-lg h-10" data-testid="status-filter">
              <SelectValue placeholder="Status" />
            </SelectTrigger>
            <SelectContent className="bg-[#1A1A1A] border-[#333333]">
              <SelectItem value="all">All Status</SelectItem>
              <SelectItem value="active">Active</SelectItem>
              <SelectItem value="banned">Banned</SelectItem>
            </SelectContent>
          </Select>
          <Button type="submit" className="bg-[#22C55E] hover:bg-[#1EA34B] text-black font-semibold rounded-lg h-10 px-6" data-testid="search-button">
            Search
          </Button>
        </form>
      </CardContent>
    </Card>
  );
}
